import React, { useState } from "react";

import Carousel from "@/src/components/common/carousel";
import TestCard from "../common/testCard";

const Suggestions = ({ data, displayName }) => {
    return (
        <section className="pt-4 md:pt-8">
            <div className="max-w-6xl mx-auto">
                <h2 className="mb-3 md:mb-6 text-xl md:text-2xl font-semibold tracking-tight text-slate-900">
                    {displayName}
                </h2>

                <Carousel
                    settings={{
                        speed: 700,
                        slidesToShow: 3,
                        slidesToScroll: 2,
                        responsive: [
                            {
                                breakpoint: 600,
                                settings: {
                                    slidesToShow: 1, // Show 1 slide on smaller screens
                                },
                            },
                        ],
                        //  focusOnSelect: false,
                        // beforeChange: (current, next) => {
                        //     document
                        //         .querySelectorAll(".slick-slide")
                        //         .forEach((slide) => {
                        //             const isCurrent =
                        //                 slide.getAttribute("data-index") ==
                        //                 next;

                        //             slide.setAttribute(
                        //                 "aria-hidden",
                        //                 !isCurrent
                        //             );

                        //             const focusableElements =
                        //                 slide.querySelectorAll(
                        //                     "a, button, input, [tabindex]"
                        //                 );
                        //             focusableElements.forEach((el) => {
                        //                 el.setAttribute(
                        //                     "tabindex",
                        //                     isCurrent ? "0" : "-1"
                        //                 );
                        //             });
                        //         });
                        // },
                    }}
                >
                    {data?.length > 0 &&
                        data.map((item, index) => (
                            <TestCard
                                key={index}
                                item={item}
                                isSpacing={true}
                            />
                        ))}
                </Carousel>
            </div>
        </section>
    );
};

export default Suggestions;
